// THE REMINDERS IN AN AI ANSWER — the `reminders` view (functions/
// workspaceAnswer.js workspaceAiViews): the reminders app's own groups
// (overdue, today, tomorrow, upcoming, no date, completed) in the shared list
// frame (components/AssistantViewList.js). A row opens Reminders. Read-only.
export const RemindersAnswerView = {
  extends: 'AssistantViewList',
  dataAnswerView: 'reminders',
  viewLoad: 'remindersAnswerLoad',
  viewModel: 'remindersAnswerModel'
}
